<template>
  <div id="shopping-index">
    <shoppingBanner/>

    <div class="wrap">
      <div class="wrap_zh">
        <div class="shopping-title">
          <div class="shopping-title_name fl">当季新品</div>
          <div class="shopping-title_info fl">当红明星产品，尽在热销</div>
        </div>
      </div>
    </div>

    <div class="wrap">
      <div class="wrap_zh">
        <div class="recommend fl">
          <div
            class="recommend-goods fl"
            :class="fingerNum == index && 'on'"
            v-for="(s, index) in newArr"
            :key="index"
            @mouseover="operaFinger(index)"
            @mouseleave="operaFingerLeave"
          >
            <div class="recommend-hots fl">
              <span>HOT</span>
            </div>
            <router-link to>
              <div class="recommend-goods_title fl">{{s.productName}}</div>
              <div class="recommend-goods_info fl">¥ {{s.price}}</div>
              <div class="recommend-goods_img fl">
                <img :src="s.productImgUrl" alt>
              </div>
            </router-link>
            <div class="recommend-goods_car fl">
              <div class="recommend-goods_car-btn fr" @click="operaAddShoppingCar(s)">
                <img src="../../assets/images/shopping/home_icon_shoppingcart2.png" alt>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh">
        <div class="shopping-title">
          <div class="shopping-title_name fl">推荐专区</div>
        </div>
      </div>
    </div>

    <div class="wrap">
      <div class="wrap_zh">
        <div class="recommend fl">
          <div
            class="recommend-goods-sai fl"
            :class="recommendNum == index && 'on'"
            v-for="(s, index) in recommendArr"
            :key="index"
            @mouseover="operaComFinger(index)"
            @mouseleave="operaFingerLeave"
          >
            <div class="recommend-hots fl" :class="'hots'+index">
              <dl>
                <dt v-if="index == 0">新品</dt>
                <dt v-if="index == 1">特惠</dt>
                <dt v-if="index == 2">人气</dt>
                <dt v-if="index == 3">优选</dt>
                <dd>推荐</dd>
              </dl>
            </div>
            <router-link to>
              <div class="recommend-goods_title fl">{{recommendArr[0].productName}}</div>
              <div class="recommend-goods_info fl">¥ {{recommendArr[0].price}}</div>
              <div class="recommend-goods_img fl">
                <img :src="recommendArr[0].productImgUrl" alt>
              </div>
            </router-link>
            <div class="recommend-goods_car fl">
              <div class="recommend-goods_car-btn fr" @click="operaAddShoppingCar(s)">
                <img src="../../assets/images/shopping/home_icon_shoppingcart2.png" alt>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { listProductAll, addProductCar } from "@/api";
import shoppingBanner from "@/components/shoppingMall/shoppingBanner";
import shoppingPublic from "@/assets/js/shoppingPublic";

export default {
  name: "shopping-index",
  components: {
    shoppingBanner
  },
  data() {
    return {
      prams: {
        currentPage: 1,
        pageSize: 10,
        category: "CP"
      },
      newArr: [],
      recommendArr: [],
      fingerNum: "leave",
      recommendNum: "leave"
    };
  },
  created() {
    this.operaGetIndexList();
  },
  methods: {
    operaGetIndexList() {
      listProductAll(this.prams).then(res => {
        this.newArr = res.obj.list.slice(0, 4);
        this.recommendArr = res.obj.list.slice(4, 8);
        this.$store.commit('SEARCH_SHOPPING_GOODS','');
      });
    },
    //添加購物車
    operaAddShoppingCar(obj) {
      let requestObj = {};
      requestObj.productId = obj.id;
      requestObj.price = obj.price;
      requestObj.quantity = 1;
      requestObj.subtotal = shoppingPublic.computePrice(obj.price * 1, 2);
      requestObj.productSpec = obj.productSpec;
      requestObj.systemType = this.$store.state.userInfo.brandId;
      requestObj.userId = this.$store.state.userInfo.staffId;
      addProductCar(requestObj).then(res => {
        if (res.code == 20001) {
          this.$emit("shoppingCars", "shoppingIndex");
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },
    operaFinger(index) {
      this.fingerNum = index;
    },
    operaComFinger(index) {
      this.recommendNum = index;
    },
    operaFingerLeave() {
      this.fingerNum = "leave";
      this.recommendNum = "leave";
    }
  }
};
</script>
<style type="text/css">
/*推荐商品*/
.recommend {
  width: 1217px;
}
.recommend-goods-sai {
  margin-top: 27px;
  margin-bottom: 10px;
  margin-left: 8px;
  margin-right: 8px;
  width: 285px;
  height: 380px;
  background: #ffffff;
}
.recommend-goods-sai.on,
.recommend-goods.on {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
}
.recommend-goods {
  margin-top: 27px;
  margin-bottom: 10px;
  margin-left: 8px;
  margin-right: 8px;
  width: 285px;
  height: 340px;
  background: #ffffff;
}
.recommend-hots {
  padding-top: 25px;
  width: 100%;
}
.recommend-hots span {
  float: right;
  margin-right: 20px;
  width: 42px;
  height: 18px;
  font-size: 10px;
  color: #ffffff;
  line-height: 18px;
  text-align: center;
  background: #f83c57;
  border-radius: 10px 9px 9px 0px;
}
.recommend-goods_title {
  width: 100%;
  line-height: 16px;
  font-size: 16px;
  color: #444444;
  text-align: center;
}
.recommend-goods_info {
  padding-top: 15px;
  width: 100%;
  line-height: 14px;
  font-size: 14px;
  color: #f83b56;
  text-align: center;
}
.recommend-goods_img {
  padding-top: 70px;
  width: 100%;
  text-align: center;
}
.recommend-goods_img img {
  width: 166px;
  height: 106px;
}
.recommend-goods-sai .recommend-hots {
  margin-top: 0;
  padding-top: 0;
  margin-bottom: 23px;
}
.recommend-goods-sai .recommend-hots dl {
  width: 70px;
  height: 60px;
  border-radius: 0px 10px 10px 0px;
}
.recommend-goods-sai .recommend-hots dt,
.recommend-goods-sai .recommend-hots dd {
  float: left;
  width: 100%;
  text-align: center;
  font-size: 15px;
  color: #ffffff;
}
.recommend-goods-sai .recommend-hots dt {
  padding-top: 10px;
}
.hots0 dl {
  background: #f83b56;
}
.hots1 dl {
  background: #ff9f41;
}
.hots2 dl {
  background: #9d3bf8;
}
.hots3 dl {
  background: #37cf9b;
}
.recommend-goods_car {
  padding-top: 21px;
  width: 100%;
}
.recommend-goods_car-btn {
  margin-right: 16px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  background: #f83c57;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingIndex.vue